/**
 * WI-F7 — e-signature send payload shape (ADO #38535).
 *
 * The verified backend contract (US-7.6) reads the raw JWT at
 * `eSignatureObj.token.raw`. This REPLACES the old
 * `eSignatureObj: { token: oktaResponse.accessToken }` shape.
 *
 * The backend derives the provider from tenant settings, so `provider` is
 * DELIBERATELY NOT part of this payload.
 */
export interface ESignatureObj {
  token: { raw: string | undefined };
}

/** Build the `eSignatureObj` sent with a completed e-signed task. */
export const buildESignatureObj = (rawToken?: string): ESignatureObj => ({
  token: { raw: rawToken },
});
